export const FETCH_REGION_RESULTS = 'MyResults/FETCH_REGION_RESULTS'
export const FETCH_REGION_RESULTS_ERROR = 'MyResults/FETCH_REGION_RESULTS_ERROR'
export const FETCH_REGION_RESULTS_SUCCESS = 'MyResults/FETCH_REGION_RESULTS_SUCCESS'

export const FETCH_DISTRICT_RESULTS = 'MyResults/FETCH_DISTRICT_RESULTS'
export const FETCH_DISTRICT_RESULTS_ERROR = 'MyResults/FETCH_DISTRICT_RESULTS_ERROR'
export const FETCH_DISTRICT_RESULTS_SUCCESS = 'MyResults/FETCH_DISTRICT_RESULTS_SUCCESS'
